import useAxios from 'hooks/useAxios';

export async function getItems() {
  const api = useAxios();

  try {
    const res = await api.get('/items');
    return res;
  } catch (err) {
    return err;
  }
}
